export default "__VITE_ASSET__HlEmB_Cg__"